import React from 'react';

import { Formik } from 'formik';
import { object, string } from 'yup';

import { TextFieldStyled, IconButton } from '@nike/nike-design-system-components';
import { Check } from '@nike/nike-design-system-icons';

import { COLUMN_WIDTHS } from '../../constants';

import ColumnFilterSort from '../../../components/tableServerSide/ColumnFilterSort';
import CatalogTypeTableCell from './CatalogTypeTableCell';

import { escapeSpecialCharsInFilterInput } from '../../util';

export const columnSortModifiersAccountDepartments = {
  number: null,
  name: null,
  catalogTypes: { disabled: true },
  defaultSort: { name: 'asc' }
};

export const columnFilterModifiersAccountDepartments = {
  number: { expression: '' },
  name: { expression: 'Like' },
  catalogTypes: { colId: 'catalogTypeName', expression: 'Like', value: escapeSpecialCharsInFilterInput }
};

const validationSchema = object().shape({
  poPrefix: string()
    .matches(/^[a-zA-Z0-9 ]*$/, 'Cannot contain special characters')
    .max(15, 'Max length is 15')
});

export const getAccountDepartmentColumns = ({
  departments,
  openAddCatalogTypeModal,
  openRemoveCatalogTypeModal,
  setSelectedDepartments,
  setSelectedCatalogType,
  updateDepartmentPoPrefix
}) => {
  return [
    {
      Header: tableInstance => (
        <ColumnFilterSort header='Department Number' tableInstance={tableInstance} align='right' />
      ),
      accessor: 'number',
      width: COLUMN_WIDTHS.MD
    },
    {
      Header: tableInstance => <ColumnFilterSort header='Department Name' tableInstance={tableInstance} />,
      accessor: 'name',
      width: COLUMN_WIDTHS.LG,
      // eslint-disable-next-line react/prop-types
      Cell: ({ value }) => {
        return <span data-testid='departmentName'>{value}</span>;
      }
    },
    {
      Header: tableInstance => <ColumnFilterSort header='Event Code Prefix' tableInstance={tableInstance} />,
      accessor: 'poPrefix',
      width: COLUMN_WIDTHS.LG,
      // eslint-disable-next-line react/prop-types
      Cell: ({ value, row }) => {
        return (
          <Formik
            initialValues={{ poPrefix: value || '' }}
            validationSchema={validationSchema}
            onSubmit={({ poPrefix }) => {
              // eslint-disable-next-line react/prop-types
              updateDepartmentPoPrefix({ poPrefix, departmentId: row.original.id });
            }}
            enableReinitialize
          >
            {({ values, handleChange, handleSubmit, dirty, touched, errors }) => {
              return (
                <form onSubmit={handleSubmit}>
                  <div style={{ display: 'flex', width: '100%' }}>
                    <TextFieldStyled
                      id='poPrefix'
                      name='poPrefix'
                      label='Event Code Prefix'
                      autoComplete='off'
                      value={values.poPrefix}
                      error={errors.poPrefix}
                      errorMessage={errors.poPrefix || null}
                      onChange={handleChange}
                    />
                    <div style={{ alignContent: 'center', position: 'relative', top: '-4px', paddingLeft: '12px' }}>
                      <IconButton
                        Icon={<Check />}
                        appearance='secondary'
                        size='small'
                        type='submit'
                        disabled={(!dirty && !touched.poPrefix) || errors.poPrefix}
                      />
                    </div>
                  </div>
                </form>
              );
            }}
          </Formik>
        );
      }
    },
    {
      Header: tableInstance => <ColumnFilterSort header='Catalog Type' tableInstance={tableInstance} />,
      // Header: 'Catalog Type',
      id: 'catalogTypes',
      width: COLUMN_WIDTHS.XXL,
      accessor: originalRow => ({
        departmentId: originalRow.id
      }),
      // eslint-disable-next-line react/prop-types
      Cell: ({ value: { departmentId } }) => {
        return (
          <CatalogTypeTableCell
            department={departments.find(dep => dep.id === departmentId)}
            openAddCatalogTypeModal={openAddCatalogTypeModal}
            openRemoveCatalogTypeModal={openRemoveCatalogTypeModal}
            setSelectedDepartments={setSelectedDepartments}
            setSelectedCatalogType={setSelectedCatalogType}
          />
        );
      }
    }
  ];
};
